import { Application } from '@hotwired/stimulus';
import type { elco } from '../base';

import AddressInputController from './controllers/address-input-controller';
import AddressSelectorController from './controllers/address-selector-controller';
import AlertController from './controllers/alert-controller';
import BackButtonController from './controllers/back-button-controller';
import CarouselController from './controllers/carousel-controller';
import CharLimitController from './controllers/char-limit-controller';
import DateDisplayController from './controllers/date-display-controller';
import DateInputController from './controllers/date-input-controller';
import DismissibleController from './controllers/dismissible-controller';
import DrawerController from './controllers/drawer-controller';
import FormAutoFocusController from './controllers/form-autofocus-controller';
import FormAutoSubmitController from './controllers/form-auto-submit-controller';
import GiftWrapController from './controllers/gift-wrap-controller';
import IncrementorController from './controllers/incrementor-controller';
import InputValidationController from './controllers/input-validation-controller';
import MenubarController from './controllers/menubar-controller';
import MenuController from './controllers/menu-controller';
import ModalDialogController from './controllers/modal-dialog-controller';
import OneTrustController from './controllers/vendor/onetrust-controller';
import PageController from './controllers/page-controller';
import PasswordInputController from './controllers/password-input-controller';
import PasswordValidatorController from './controllers/password-validator-controller';
import PaymentMethodSelectorController from './controllers/payment-method-selector-controller';
import PhoneInputController from './controllers/phone-input-controller';
import PopoverController from './controllers/popover-controller';
import PrivacyPortalController from './controllers/privacy-portal-controller';
import RadioToggleController from './controllers/radio-toggle-controller';
import SelectMenuController from './controllers/select-menu-controller';
import ShadeSwatchController from './controllers/shade-swatch-controller';
import StickyFooterBarController from './controllers/sticky-footer-bar-controller';
import SwitchController from './controllers/switch-controller';
import TextareaController from './controllers/textarea-controller';
import ToastController from './controllers/toast-controller';
import ToggleController from './controllers/toggle-controller';
import ToggleFormController from './controllers/toggle-form-controller';
import TooltipController from './controllers/tooltip-controller';
import VerificationCodeController from './controllers/verification-code-controller';
import TurboFormController from './controllers/turbo-form-controller';

declare global {
  interface Window {
    ELCO: elco;
    Stimulus: Application;
  }
}

window.Stimulus = Application.start();

window.ELCO.Debug.register(
  'Stimulus',
  () => (window.Stimulus.debug = true),
  () => (window.Stimulus.debug = false),
);

window.Stimulus.register('address-input', AddressInputController);
window.Stimulus.register('address-selector', AddressSelectorController);
window.Stimulus.register('alert', AlertController);
window.Stimulus.register('back-button', BackButtonController);
window.Stimulus.register('carousel', CarouselController);
window.Stimulus.register('char-limit', CharLimitController);
window.Stimulus.register('date-display', DateDisplayController);
window.Stimulus.register('date-input', DateInputController);
window.Stimulus.register('dismissible', DismissibleController);
window.Stimulus.register('drawer', DrawerController);
window.Stimulus.register('form-auto-submit', FormAutoSubmitController);
window.Stimulus.register('form-autofocus', FormAutoFocusController);
window.Stimulus.register('gift-wrap', GiftWrapController);
window.Stimulus.register('incrementor', IncrementorController);
window.Stimulus.register('input-validation', InputValidationController);
window.Stimulus.register('menu', MenuController);
window.Stimulus.register('menubar', MenubarController);
window.Stimulus.register('modal-dialog', ModalDialogController);
window.Stimulus.register('onetrust', OneTrustController);
window.Stimulus.register('page', PageController);
window.Stimulus.register('password-input', PasswordInputController);
window.Stimulus.register('password-validator', PasswordValidatorController);
window.Stimulus.register(
  'payment-method-selector',
  PaymentMethodSelectorController,
);
window.Stimulus.register('phone-input', PhoneInputController);
window.Stimulus.register('popover', PopoverController);
window.Stimulus.register('privacy-portal', PrivacyPortalController);
window.Stimulus.register('radio-toggle', RadioToggleController);
window.Stimulus.register('select-menu', SelectMenuController);
window.Stimulus.register('shade-swatch', ShadeSwatchController);
window.Stimulus.register('sticky-footer-bar', StickyFooterBarController);
window.Stimulus.register('switch', SwitchController);
window.Stimulus.register('textarea', TextareaController);
window.Stimulus.register('toast', ToastController);
window.Stimulus.register('toggle-form', ToggleFormController);
window.Stimulus.register('toggle', ToggleController);
window.Stimulus.register('tooltip', TooltipController);
window.Stimulus.register('turbo-form', TurboFormController);
window.Stimulus.register('verification-code', VerificationCodeController);
